import { useState } from "react";
import Table, { TicketTablePageFor } from "../../reports/ticketwise/Table";
import { TicketsQueryType } from "../../../../../queries/types";
import Navbar from "../../../../common/layout/Navbar";
import { LicenseTypes, PageFrom } from "../../../../../utils/Enum.types";
import { AppProvider } from "../../maps/context/context";

const DashbordTicketsDetails = () => {
  const [modalFlag, setModalFlag] = useState(false);

  return (
    <AppProvider>
      <Navbar NavType={LicenseTypes.DASHBOARD} />

      <div className="d-main-page">
        <div className="d-main-page__block">
              <b>Active Ticktes</b>
              <div className="asset-reports__right--help-block">
              <Table
              queryType={TicketsQueryType.ALL}
              pageFor={TicketTablePageFor.DASHBOARD}
              setModalFlag={setModalFlag}
              pageFrom={PageFrom.DASHBOARD}
            />
            </div>
        </div>
      </div>
    </AppProvider>
  );
};

export default DashbordTicketsDetails;
